import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import Flex from 'components/Flex';
import Text from 'components/Text';
import { formatDuration } from 'components/Duration';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MeetingTranscript(_ref) {
  var transcript = _ref.transcript,
    hasTimings = _ref.hasTimings;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Stack, {
    as: "ordered-list",
    spacing: "m",
    children: transcript.map(function (_ref2, index) {
      var speaker = _ref2.speaker,
        text = _ref2.text,
        startTime = _ref2.startTime;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(Flex, {
          gap: "xs",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(Text, {
            bold: true,
            children: speaker !== null && speaker !== void 0 ? speaker : t('modal_meeting_transcript_unknown_speaker')
          }), hasTimings && /*#__PURE__*/_jsx(Text, {
            size: "s",
            dimmed: true,
            children: formatDuration(startTime)
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          mt: "xxs",
          children: text
        })]
      }, index);
    })
  });
}
export default MeetingTranscript;